import React from "react";


const Hotspots = () => {
    return <>
        <div>Hotspots</div>
    </>
}

export default Hotspots;